import { NavigateFunction } from "react-router-dom";

export const useGoHome = (navigate: NavigateFunction) => {
  return navigate("/");
};
